"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetFavouriteApplicationCommand = void 0;
class SetFavouriteApplicationCommand {
    constructor(userId, studyId, application, expectedState, isLocal) {
        this.userId = userId;
        this.studyId = studyId;
        this.application = application;
        this.expectedState = expectedState;
        this.isLocal = isLocal;
    }
}
exports.SetFavouriteApplicationCommand = SetFavouriteApplicationCommand;
